import React, { Fragment } from "react";
import { TableCell, TableRow, makeStyles } from "@material-ui/core";

import { get } from "lodash";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
  footer: {
    textAlign: "center",
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
}));

const DeliverablesRow = ({ wps, month }) => {
  const classes = useStyles();

  return (
    <TableCell classes={classes}>
      {wps?.map((wp, index) => (
        <DeliverablesColumns
          wp={wp}
          indexWp={index}
          month={month}
          key={index}
        />
      ))}
    </TableCell>
  );
};

const DeliverablesColumns = ({ wp, month }) => {
  const wpDeliverables = get(wp, "executive_project_wp_deliverables", []);

  return wpDeliverables?.map((wpDeliverable, index) =>
    wpDeliverable.expected_month === month ? (
      <Fragment key={index}>
        {wp.index}.{wpDeliverable.index}
        <br />
      </Fragment>
    ) : null
  );
};

const WpDeliverablesRow = ({ wps, months }) => {
  const classes = useStyles();
  const translate = useTranslate();
  return (
    <TableRow>
      <TableCell classes={classes}>
        {translate("resources.crono.fields.deliverables")}
      </TableCell>
      {months?.map((month, index) => (
        <DeliverablesRow wps={wps} month={month} key={index} />
      ))}
    </TableRow>
  );
};
export default WpDeliverablesRow;
